import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { QUALIFIED_CHATBOT_ORIGIN, QUALIFIED_CHATBOT_SCRIPT_SRC } from "constants/qualified-chatbot";
const QualifiedChatbotPrefetchLinksComponent = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("link", {
                rel: "dns-prefetch",
                href: QUALIFIED_CHATBOT_ORIGIN
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "preconnect",
                href: QUALIFIED_CHATBOT_ORIGIN
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "preload",
                href: QUALIFIED_CHATBOT_SCRIPT_SRC,
                as: "script",
                fetchpriority: "high"
            })
        ]
    });
export default QualifiedChatbotPrefetchLinksComponent;
